import { MapPin, Phone, Clock } from "@phosphor-icons/react";
import { Separator } from "@/components/ui/separator";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer data-testid="site-footer" className="bg-[hsl(222,47%,11%)] text-stone-300 noise-overlay">
      <div className="relative z-10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            {/* Brand */}
            <div>
              <h3 className="font-heading font-extrabold text-xl text-white tracking-tight mb-4">
                Vu's Car Repair
              </h3>
              <p className="text-sm leading-relaxed text-stone-400 max-w-xs">
                Beaverton's most trusted mechanic. Honest repairs, fair prices, and zero upselling since day one.
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="font-heading font-bold text-sm text-white uppercase tracking-widest mb-4">
                Quick Links
              </h4>
              <nav className="flex flex-col gap-3">
                {[
                  { label: "Home", href: "#hero" },
                  { label: "Why Us", href: "#why-us" },
                  { label: "About", href: "#about" },
                  { label: "Services", href: "#services" },
                  { label: "Reviews", href: "#reviews" },
                  { label: "Contact", href: "#contact" },
                ].map((link) => (
                  <a
                    key={link.href}
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      document.querySelector(link.href)?.scrollIntoView({ behavior: "smooth" });
                    }}
                    className="text-sm text-stone-400 hover:text-primary transition-colors duration-200"
                  >
                    {link.label}
                  </a>
                ))}
              </nav>
            </div>

            {/* Contact Info */}
            <div>
              <h4 className="font-heading font-bold text-sm text-white uppercase tracking-widest mb-4">
                Contact
              </h4>
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <MapPin weight="duotone" className="w-4 h-4 text-primary mt-0.5 shrink-0" />
                  <p className="text-sm text-stone-400">
                    4400 SW 142nd Ave,
                    <br />
                    Beaverton, OR 97005
                  </p>
                </div>
                <div className="flex items-center gap-3">
                  <Phone weight="duotone" className="w-4 h-4 text-primary shrink-0" />
                  <a
                    href="tel:5036433040"
                    className="text-sm text-stone-400 hover:text-primary transition-colors duration-200"
                    data-testid="footer-phone-link"
                  >
                    (503) 643-3040
                  </a>
                </div>
                <div className="flex items-start gap-3">
                  <Clock weight="duotone" className="w-4 h-4 text-primary mt-0.5 shrink-0" />
                  <div className="text-sm text-stone-400">
                    <p>Mon – Fri: 8:00 AM – 5:00 PM</p>
                    <p>Sat – Sun: Closed</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Separator className="bg-stone-800" />

        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-stone-500">
            &copy; {currentYear} Vu's Car Repair Inc. All rights reserved.
          </p>
          <p className="text-xs text-stone-500">
            Wheelchair-accessible entrance & parking
          </p>
        </div>
      </div>
    </footer>
  );
}
